export const YYYYMMDD_HHMM = "YYYY-MM-DD HH:mm"